import { Table, Tag, Button, Space } from '@/shared/ui/primitives';
import { EditOutlined, DeleteOutlined } from '@/shared/ui/icons';
import { formatDateTime } from '@/shared/utils/formatters';
import { useTranslation } from 'react-i18next';
import type { ColumnsType, TableProps } from '@/shared/ui/subpath-types';

interface Props {
  data: any[];
  loading: boolean;
  sortField: string;
  sortDir: string;
  onSort: (field: string) => void;
  onEdit: (id: number) => void;
  onDelete: (item: any) => void;
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

export default function HousingStatusTable({ data, loading, sortField, sortDir, onSort, onEdit, onDelete, page, pageSize, total, onPageChange }: Props) {
  const { t } = useTranslation();

  const columns: ColumnsType<any> = [
    { title: t('common.id'), dataIndex: 'id', sorter: true, width: 80 },
    { title: t('housingStatuses.nameEn'), dataIndex: 'nameEn', sorter: true },
    { title: t('housingStatuses.nameAr'), dataIndex: 'nameAr', sorter: true },
    {
      title: t('common.active'), dataIndex: 'isActive', sorter: true, width: 100,
      render: (v: boolean) => <Tag color={v ? 'green' : 'red'}>{v ? t('common.active') : t('common.inactive')}</Tag>,
    },
    { title: t('common.createdAt'), dataIndex: 'createdAt', sorter: true, render: (v: string) => formatDateTime(v) },
    {
      title: t('common.actions'), width: 100,
      render: (_, record) => (
        <Space>
          <Button type="text" size="small" icon={<EditOutlined />} onClick={() => onEdit(record.id)} />
          <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={() => onDelete(record)} />
        </Space>
      ),
    },
  ];

  const handleChange: TableProps['onChange'] = (_p, _f, sorter: any) => { if (sorter?.field) onSort(sorter.field); };

  return (
    <Table rowKey="id" columns={columns} dataSource={data} loading={loading} onChange={handleChange} sortDirections={['ascend', 'descend']} showSorterTooltip={false}
      pagination={{ current: page + 1, pageSize, total, showTotal: (total) => `${total} items`, showSizeChanger: false, onChange: (p) => onPageChange(p - 1) }} />
  );
}
